import { GetVoiceAndToneCurrentAndTargetVectorsResponse } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/ContentServerProxy/types';
import { ChartDataAdapter } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/adapters/types';

// TODO(jvancamp): define the data type that the chart will use
type ProductLevelVoiceAndToneAnalysisData = any;

export class ProductLevelVoiceAndToneAnalysisAdapter implements ChartDataAdapter<ProductLevelVoiceAndToneAnalysisData> {
  data: GetVoiceAndToneCurrentAndTargetVectorsResponse;

  constructor(data: GetVoiceAndToneCurrentAndTargetVectorsResponse) {
    this.data = data;
  }

  transform(): GetVoiceAndToneCurrentAndTargetVectorsResponse {
    return this.data;
  }
}
